export default __webpack_public_path__ + "static/media/quickly1.223c2da6.png";